import React, {useState} from "react";
import {SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {SimpleSearchWithId} from "../../../../../reduxToolkit/Search/SearchApi";
import {useDispatch} from "react-redux";
import {TABLES} from "../../../../../Apis/Tables";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import CustomChip from "../../../../../components/CustomChip";
import {status} from "../../../../../enums/statusEnum";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {
    DetailsIconsOptions, IconAvatarTable, IconClockTable, IconDeskOfficeTable, IconMarkerTable, IconScheduleTable
} from "../../../../../components/buttons/IconButtons";
import TableFunction from "../../../../../components/table/TableFunction";
import {EMPTY_VALUES, getDateFormat, getTimeFormat} from "../../../../../Apis/functions";
import {colors} from "../../../../../enums/colors";
import {INVITATION_VIEW_TYPE} from "../../Invitation/Model/Model";
import {MODAL_DETAILS_OPTIONS} from "../Model/Model";

/**
 * @author Karen Yunuen Pozos Arias
 * @email kpozos@ibl.mx
 * @title Full Stack Developer
 * @component VisitorHistoryTableApp
 * @description Renders the history table for a specific visitor item.
 *
 * @param {Object} item - Visitor object containing the visitor's unique identifier and related information.
 *
 */

export const  VisitorHistoryTableApp = ({ item}) => {
    const dispatch = useDispatch();
    const [modified, setModified] = useState(false);
    const [tableId, setTableId] = useState("tbl_vhta_invitation_history"); // Set the table ID for identification
    const searchId = 'txt_vhta_search_invitation_history';
    const [results, setResults] = useState(null); // Store the search results
    const option = TABLES.USER_INVITATION;
    const [simpleDetailsModal, setSimpleDetailsModal] = useState(false);
    const [completeDetailsModal, setCompleteDetailsModal] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    const [bodyForExport, setBodyForExport] = useState('');
    const [searchElement, setSearchElement] = useState('');
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const [search, setSearch] = useState(false);

    /**
     * Generates the table header columns.
     * @returns {React.ReactNode[]} Array of header cells.
     */
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes="first_head">{t('host')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('start_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('end_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('access_zone')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('visitor_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('approvalStatus')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('visitorStatus')}</CustomTh>,
        ];
    };
    /**
     * Generates the table body rows based on fetched data.
     * @returns {{ body: React.ReactNode[], data: Object[] }} Rendered table rows and raw data.
     */
    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item, index) => {
            let fullName = (`${item?.hostName} ${item?.hostLastName} ${item?.hostSecondLastName? item?.hostSecondLastName: ""}`);
            let visitorStatusId = item?.visitorStatusId;
            let approvalStatusId = item?.approvalStatusId;
            let statusId = item?.statusId;

            return (
                <>
                    <CustomTd tableId={tableId} classes={"first-column "}>
                        <div className={"d-flex"}>
                            <div><IconAvatarTable className={"mr-8px mb-1"}/></div>
                            {fullName}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <div><IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"}/></div>
                            {getDateFormat(item?.startDate,false)}
                        </div>
                        <div className={"d-flex"}>
                            <div><IconClockTable className={"mr-8px mb-1 icon-color-general-950"}/></div>
                            {getTimeFormat(item?.startDate)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <div><IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"}/></div>
                            {getDateFormat(item?.endDate,false)}
                        </div>
                        <div className={"d-flex"}>
                            <div><IconClockTable className={"mr-8px mb-1 icon-color-general-950"}/></div>
                            {getTimeFormat(item?.endDate)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.rootFatherZoneName &&
                        <div className={"d-flex"}>
                            <div><IconMarkerTable className={"mr-8px mb-1"}/></div>
                            {item?.rootFatherZoneName}
                        </div>
                        }

                        <div className={"d-flex"}>
                            {item?.rootFatherZoneName ?
                                <div><IconDeskOfficeTable className={"mr-8px mb-1"}/></div> : <div><IconMarkerTable className={"mr-8px mb-1"}/></div>}
                            {item?.zoneName}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={item?.visitorType?.name || EMPTY_VALUES.DEFAULT}
                            variant={'compact'}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={t(status[approvalStatusId])}
                                    borderColor={statusBorderColor[approvalStatusId]}
                                    fontColor={statusFontColor[approvalStatusId]}
                                    background={statusColor[approvalStatusId]}
                                    variant={'large'}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={t(status[statusId])}
                                    borderColor={statusBorderColor[statusId]}
                                    fontColor={statusFontColor[statusId]}
                                    background={statusColor[statusId]}
                                    variant={'large'}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={t(status[visitorStatusId])}
                                    borderColor={statusBorderColor[visitorStatusId]}
                                    fontColor={statusFontColor[visitorStatusId]}
                                    background={statusColor[visitorStatusId]}
                                    variant={"large"}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body, // Return the generated table rows
            data: results?.content // Return the data associated with the rows
        };
    };


    /**
     * Renders dropdown action buttons per table row based on user permissions.
     * @param {Object} item - Current table row data.
     * @param {number} index - Index of the row.
     * @returns {React.ReactNode} Dropdown menu with actions.
     */
    const getActionsButtons = (item, index) => {

        return <>
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`} // Unique menu ID for each contractor
            >
                <DropDownMenuItem
                    id={"btn_vhta_details_" + item?.id}
                    index={index}
                    handleClose={handleClose}
                    name={t('details')}
                    click={() => {
                        setItemSelected(item);
                        if(MODAL_DETAILS_OPTIONS.getOption(item?.visitorStatusId) === MODAL_DETAILS_OPTIONS.SIMPLE.name)
                            setSimpleDetailsModal(true);
                        else
                            setCompleteDetailsModal(true);
                    }}
                    icon={<DetailsIconsOptions/>}
                />
            </DropDownMenuProfile>
        </>;
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, userId: item.id, viewType: INVITATION_VIEW_TYPE.HISTORY, key:searchElement});
        dispatch(SimpleSearchWithId({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }
    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { thead,tbody, t, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage,
        openMenu, handleMenuToggle, handleClose} = TableFunction({
        getTbody: getTbody,
        getThead: getThead,
        data: results,
        labelRowsPerPage: 'invitation_per_page',
        hasContainer: true,
        fixedPagination: false,
        searchElement,//New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        tableId,
        searchId,
        option,
        thead,
        tbody,
        simpleDetailsModal,
        setSimpleDetailsModal,
        completeDetailsModal,
        setCompleteDetailsModal,
        itemSelected,
        setItemSelected,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setResults,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        pagination,
        getActionsButtons,
    };
};
